import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/Login.css';

import logo from '../../../app_icon.svg';
import Modal from '../../../common/components/MessageModal';
import { loginUser } from '../../../api/auth';

import user from '../../../assets/icons/user.svg';
import briefcase from '../../../assets/icons/briefcase.svg';
import PhoneInput from '../../../common/components/PhoneInput';
import { t } from 'i18next';

import { trackPageView } from '../../../utils/AnalyticsUtils';
import monitoringService from '../../../services/monitoringService';

const Login = () => {
    const navigate = useNavigate();
    const [phone, setPhone] = useState('');
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [error, setError] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        trackPageView('login');

        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const accessToken = localStorage.getItem('access_token');
        if (accessToken) {
            navigate('/profile#walletTopUp');
        }
    }, [navigate]);

    const handleBackClick = () => {
        navigate('/');
    };

    const handleCountryChange = (country) => {
        setSelectedCountry(country);
    };

    const handlePhoneChange = (e) => {
        setPhone(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!phone.trim()) {
            setError(t('enter_phone'));
            setShowModal(true);
            return;
        }
    
        // Get country code from selected country or default to +7
        const countryCode = selectedCountry?.code || '+7';
        const sanitizedPhoneNumber = phone.replace(/\D/g, '');
        const formattedPhoneNumber = `${countryCode}${sanitizedPhoneNumber}`;
    
        try {
            const data = await loginUser(formattedPhoneNumber);
            // Track login attempt (will be updated to success in SmsCode)
            monitoringService.trackLogin(formattedPhoneNumber, false, null).catch(err => {
                console.warn('Failed to track login attempt:', err);
            });
            navigate('/sms-code', { 
                state: { 
                    taskId: data.links[0].href.split('/').pop(), 
                    phoneNumber: formattedPhoneNumber, 
                    typeAuth: 'login',
                    email: data.email || null,
                    hasEmailOption: data.links?.some(link => link.name === 'mfaEmailRequest') || false
                } 
            });
        } catch (error) {
            const errorMessage = error.message || 'Ошибка сети. Попробуйте позже.';
            // Track login failure
            monitoringService.trackLogin(formattedPhoneNumber, false, errorMessage).catch(err => {
                console.warn('Failed to track login failure:', err);
            });
            setError(errorMessage);
            setShowModal(true);
        }
    };    

    const handleCloseModal = () => {
        setShowModal(false);
        setError('');
    };

    return (
        <div className="sign_page">
            <div className="left_section"></div>

            <div className="right_section">
                <div className="right_section_header">
                    <button onClick={handleBackClick} className="back_button">
                        <i className="back_icon fa-solid fa-chevron-left"></i>
                        {isMobile ? t('signIn') : t('back')}
                    </button>

                    {!isMobile &&
                        <div className="logo_container">
                            <img src={logo} alt="Agroland" className="logo" />
                        </div>
                    }
                </div>
                <form onSubmit={handleSubmit} className="sign_form">
                    {isMobile &&
                        <div className="logo_container">
                            <img src={logo} alt="Logo" className="form_logo" />
                        </div>
                    }
                    {!isMobile &&
                        <h2 className="title">{t('signIn')}</h2>
                    }
                    <PhoneInput
                        label={t('enter_phone')}
                        value={phone}
                        onChange={handlePhoneChange}
                        onCountryChange={handleCountryChange}
                    />
                    <button type="submit" className="submit_button">
                        {t('next')}
                    </button>
                </form>

                <div className="registration_section_buttons">
                    <button
                        onClick={() => navigate('/register', { state: { userType: 'individual' } })}
                        className="register_button"
                    >
                        {t('forIndividuals')} <img className="green_icon" src={user} alt="User Icon" />
                    </button>
                    <button
                        onClick={() => navigate('/register', { state: { userType: 'business' } })}
                        className="register_button"
                    >
                        {t('forBusinesses')} <img src={briefcase} alt="Briefcase Icon" />
                    </button>
                </div>
            </div>

            <Modal show={showModal} message={error} onClose={handleCloseModal} />
        </div>
    );
};

export default Login;